import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate } from 'react-router-dom';

import {
  headersEntregasContratos,
  headersObjetosContratos,
  headersParcelasContratos,
  headersPautasEntregasContratos,
  valoresExibidosOffCanvasContratos,
} from './auxiliarContratos';
import { SubAbasContratos, SubAbasContratosNovo } from './subabasContratos';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import ModalTwo from '../../../../components/ModalTwo';
import SubAbas from '../../../../components/SubAbas';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import { LogData } from '../../../../modules/types/types';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { useStatusVersao } from '../../../../services/enum/useStatusVersao';
import { getNotaVersao } from '../../../../services/gestaoSisAF/notaVersaoSisafService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import theme from '../../../../theme';
import { formataNomeMeioSiglas } from '../../../../utils/functions';
import {
  swal,
  swalAtualizacao,
  swalSave,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
} from '../../../../utils/swal';

//DADOS USUARIO
const user = getUser();
const userID = user.sub;
//const entity = ENTITY.ENTITY_Contratos;

export default function ContratosFicha() {
  //PERMISSOES-MODULOS
  const papelUsuarioOptions = usePapelUsuario();
  const moduloUsuarioOptions = useModuloUsuario();
  // Obter o módulo
  const MODULO = Number(
    moduloUsuarioOptions.find((modulo) => modulo.label === 'Contratos')
      ?.value || '0',
  );

  // Verificar permissões para ações
  // const canDownload = isActionAllowed(MODULO, 'read', papelUsuarioOptions);
  //const canInsert = isActionAllowed(MODULO, 'create', papelUsuarioOptions);
  const canDelete = isActionAllowed(MODULO, 'delete', papelUsuarioOptions);
  const canSave = isActionAllowed(MODULO, 'update', papelUsuarioOptions);
  //PERMISSOES

  const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  //Dados do componente
  let logs = {};
  let subAbas = [];

  const statusVersao = useStatusVersao();

  //States

  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  //States e Forms Objetos
  const [showModalObjeto, setShowModalObjeto] = useState<boolean>(false);
  const [logObjetoData] = useState<LogData>();
  const [updatingObjeto] = useState<boolean>(false);
  // const [formObjeto, setFormObjeto] = useState({
  //   id: '',
  //   usuarioId: userID,
  //   arpId: 0,
  //   produtoDafId: 0,
  //   tipoCota: 0,
  //   empateFicto: 0,
  //   qtdItem: '',
  //   observacoes: '',
  // });

  //States e Forms Parcelas
  const [showModalParcela, setShowModalParcela] = useState<boolean>(false);
  const [updatingParcela] = useState<boolean>(false);
  // const [formParcela, setFormParcela] = useState({
  //   id: '',
  //   usuarioId: userID,
  //   arpId: 0,
  //   produtoDafId: 0,
  //   tipoCota: 0,
  //   empateFicto: 0,
  //   qtdItem: '',
  //   observacoes: '',
  // });

  //States e Forms Pautas
  const [showModalPauta, setShowModalPauta] = useState<boolean>(false);
  const [updatingPauta] = useState<boolean>(false);
  // const [formPauta, setFormPauta] = useState({
  //   id: '',
  //   usuarioId: userID,
  //   arpId: 0,
  //   produtoDafId: 0,
  //   tipoCota: 0,
  //   empateFicto: 0,
  //   qtdItem: '',
  //   observacoes: '',
  // });

  //States e Forms Entregas
  const [showModalEntrega, setShowModalEntrega] = useState<boolean>(false);
  const [updatingEntrega] = useState<boolean>(false);
  // const [formEntrega, setFormEntrega] = useState({
  //   id: '',
  //   usuarioId: userID,
  //   arpId: 0,
  //   produtoDafId: 0,
  //   tipoCota: 0,
  //   empateFicto: 0,
  //   qtdItem: '',
  //   observacoes: '',
  // });

  const [formNotaVersao, setFormNotaVersao] = useState({
    usuarioId: userID,
    statusVersao: '',
    dataVersao: '',
    tagVersao: '',
    descricao: '',
    link: '',
    observacoes: '',
  });

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const registroData = await getNotaVersao(id);
      setLogData(registroData);
      setFormNotaVersao({
        usuarioId: userID,
        statusVersao: registroData.statusVersao,
        dataVersao: registroData.dataVersao,
        tagVersao: registroData.tagVersao,
        descricao: registroData.descricao,
        link: registroData.link,
        observacoes: registroData.observacoes,
      });
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //
  const [statusStyle, setStatusStyle] = useState<React.CSSProperties>({});
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';
    const amarelo = '#faffb4dd';

    console.log('Status:', formNotaVersao.statusVersao);

    const status = String(formNotaVersao.statusVersao);
    console.log('Status atual:', status); // Adicionado para depurar

    const newStatusStyle = {
      backgroundColor:
        status === '1'
          ? amarelo
          : status === '2'
            ? verde
            : status === '3'
              ? vermelho
              : 'white',
    };

    setStatusStyle(newStatusStyle);
  }, [formNotaVersao.statusVersao]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isDateReadOnly, setIsDateReadOnly] = useState(true);
  useEffect(() => {
    if (
      formNotaVersao.statusVersao == '1' ||
      formNotaVersao.statusVersao == '3'
    ) {
      setIsDateReadOnly(true);
      setFormNotaVersao((prev) => ({
        ...prev,
        dataVersao: '',
      }));
    } else {
      setIsDateReadOnly(false);
    }
  }, [formNotaVersao.statusVersao]);

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID); // Chama a função para buscar dados quando o comp
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasContratos(fichaID);
  } else {
    subAbas = SubAbasContratosNovo;
  }

  //Funções Handle
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;
    console.log('Campo alterado:', name, 'Novo valor:', value); // Verificar qual campo está sendo alterado e o valor
    setFormNotaVersao((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.statusVersao) {
      errors.push('<b>Status da versão</b> é obrigatório.');
    }

    if (!form.tagVersao) {
      errors.push('Nome da <b>tag da versão</b> é obrigatório.');
    }

    if (!form.descricao) {
      errors.push('<b>Descrição</b> é obrigatório.');
    }

    if (form.statusVersao == '2' && form.dataVersao == '') {
      errors.push('<b>Data da versão</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalErro(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const handleCreate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formNotaVersao);
      if (!isFormValid) return;

      console.log(formNotaVersao);

      const formToSend = {
        ...formNotaVersao,
        statusVersao: Number(formNotaVersao.statusVersao),
        dataVersao: formNotaVersao.dataVersao
          ? formNotaVersao.dataVersao
          : null,
      };

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(
        `/api/notaversaosisaf/`,
        formToSend,
      );

      swalSave();
      setTimeout(
        () =>
          (window.location.href = `#/daf/maisopcoes/notas/ficha/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleUpdate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formNotaVersao);
      if (!isFormValid) return;

      const formToSend = {
        ...formNotaVersao,
        statusVersao: Number(formNotaVersao.statusVersao),
        dataVersao: formNotaVersao.dataVersao
          ? formNotaVersao.dataVersao
          : null,
      };

      const response = await httpClient.patch(
        `/api/notaversaosisaf/${fichaID}`,
        formToSend,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registro.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
      console.log(error.message);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) {
      return;
    }

    if (result) {
      try {
        await httpClient.delete(`/api/notaversaosisaf/${fichaID}`);
        swalDeleteConfirm();
        navigate('/fornecedor/maisopcoes/notas');
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  const handleRowClickObjeto = () => {
    alert('teste');
  };

  const tableObjetos = [
    {
      id: 0,
      itemTipoCota: 0,
      itemQtdRegistrada: 0,
      itemValorHomologado: 0,
      itemValorReequilibrio: 0,
      itemValorTotal: 0,
    },
  ];

  const handleShowModalObjeto = () => {
    setShowModalObjeto((prev) => !prev);
  };

  const handleShowModalParcela = () => {
    setShowModalParcela((prev) => !prev);
  };

  const handleShowModalPauta = () => {
    setShowModalPauta((prev) => !prev);
  };

  const handleShowModalEntrega = () => {
    setShowModalEntrega((prev) => !prev);
  };

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/fornecedor/contratos/contratos"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <Log {...logs} />

          {/* Identificação do Contrato */}
          <BoxConteudo boxTitulo="Identificação do Contrato">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="200px">
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="Status"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="unidadeDaf"
                  options={statusVersao}
                  label="Unidade DAF"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
              <CustomCol width="250px">
                <SelectInput
                  name="leiLicitacao"
                  options={statusVersao}
                  label="Lei de Licitação"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
              <CustomCol width="250px">
                <SelectInput
                  name="leiLicitacao"
                  options={statusVersao}
                  label="Modalidade de Aquisição"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>

              <CustomCol>
                <Input
                  name="link"
                  label="Nº da ARP"
                  value="151/2013"
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textDecoration: 'underline' }}
                />
              </CustomCol>
              <CustomCol width="250px">
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="Tipo de Contrato"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
            </CustomRow>

            <CustomRow>
              <CustomCol width="250px">
                <Input
                  name="numeroArp"
                  label="Nº Processo SEI"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="numeroArp"
                  label="Documento SEI"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="numeroArp"
                  label="Número do Contrato"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
              <CustomCol width="300px">
                <Input
                  name="numeroArp"
                  label="Valor Total R$"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol width="150px">
                <Input
                  name="numeroArp"
                  label="Objetos"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol width="150px">
                <Input
                  name="numeroArp"
                  label="Parcelas"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
            </CustomRow>

            {/* Denominação Genérica / Kit de Produto */}
            <CustomRow>
              <CustomCol>
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="Denominação Genérica"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
            </CustomRow>

            {/* Fornecedor */}
            <CustomRow>
              <CustomCol>
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="Fornecedor"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
            </CustomRow>

            {/* Fiscal do Contrato */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="numeroArp"
                  label="Fiscal do Contrato"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          {/* Objetos do Contrato */}
          <BoxConteudo boxTitulo="Objetos" fechado>
            <CustomRow>
              <CustomCol width="100%">
                <Tabela
                  headers={headersObjetosContratos}
                  dataTable={tableObjetos}
                  displayValues={valoresExibidosOffCanvasContratos}
                  onRowClick={handleRowClickObjeto}
                  dataOffCanvas={tableObjetos}
                  botaoAbrirOffCanvas={false}
                />
              </CustomCol>
            </CustomRow>
            <CustomCol style={{ marginTop: '15px', textAlign: 'right' }}>
              <CustomButton
                label="Novo Objeto"
                bgColor={theme.colors.botaoAcao.azul}
                textColor={theme.colors.white}
                onClick={() => {
                  handleShowModalObjeto();
                }}
              />
            </CustomCol>

            {/* Modal Objeto /*/}
            <ModalTwo
              tituloModal="Objeto do Contrato"
              open={showModalObjeto}
              onHide={handleShowModalObjeto}
              icone="inventory"
              height="70vh"
              width="70vw"
              footer={
                <BarraInferiorBotoes>
                  {updatingObjeto ? (
                    <WorkspaceBotoes
                      delete
                      onClickDelete={handleDelete}
                      save
                      onClickSave={handleUpdate}
                    />
                  ) : (
                    <WorkspaceBotoes inserir onClickInserir={handleCreate} />
                  )}
                </BarraInferiorBotoes>
              }
            >
              <WorkspaceFicha>
                <Log {...logObjetoData} />
                <BoxConteudo boxTitulo="Dados do Objeto">
                  <CustomRow style={{ marginTop: '-15px' }}>
                    <CustomCol width="75px">
                      <Input
                        name="link"
                        label="Nº"
                        value={1}
                        id="tagVersao"
                        type="number"
                        onChange={handleChange}
                      />
                    </CustomCol>
                    <CustomCol>
                      <SelectInput
                        name="statusVersao"
                        options={statusVersao}
                        label="Produto Farmacêutico"
                        value={formNotaVersao.statusVersao}
                        onChange={handleChange}
                        style={statusStyle}
                      />
                    </CustomCol>
                  </CustomRow>
                  <CustomRow>
                    <CustomCol width="175px">
                      <Input
                        name="link"
                        label="Fator Embalagem"
                        value={1}
                        id="tagVersao"
                        type="number"
                        onChange={handleChange}
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="100px">
                      <Input
                        name="link"
                        label="Parcelas"
                        value={1}
                        id="tagVersao"
                        type="integer"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="220px">
                      <Input
                        name="link"
                        label="Qtd Contratada"
                        value={1}
                        id="tagVersao"
                        type="integer"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="220px">
                      <Input
                        name="link"
                        label="Qtd Doada"
                        value={1}
                        id="tagVersao"
                        type="integer"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="220px">
                      <Input
                        name="link"
                        label="Qtd Total"
                        value={1}
                        id="tagVersao"
                        type="integer"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="150px">
                      <Input
                        name="link"
                        label="Valor Unitário R$"
                        value={1}
                        id="tagVersao"
                        onChange={handleChange}
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol>
                      <Input
                        name="link"
                        label="Valor Total R$"
                        value={1}
                        id="tagVersao"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                  </CustomRow>
                </BoxConteudo>
                <BoxConteudo boxTitulo="Observações" fechado>
                  <CustomRow style={{ marginTop: '-15px' }}>
                    <CustomCol>
                      <Input
                        id="observacoes"
                        name="observacoes"
                        value={formNotaVersao.observacoes}
                        label=""
                        type="textarea"
                        onChange={handleChange}
                        linhas={7}
                      />
                    </CustomCol>
                  </CustomRow>
                </BoxConteudo>
              </WorkspaceFicha>
            </ModalTwo>
          </BoxConteudo>

          {/* Parcelas do Contrato */}
          <BoxConteudo boxTitulo="Parcelas" fechado>
            <CustomRow>
              <CustomCol width="100%">
                <Tabela
                  headers={headersParcelasContratos}
                  dataTable={tableObjetos}
                  displayValues={valoresExibidosOffCanvasContratos}
                  onRowClick={handleRowClickObjeto}
                  dataOffCanvas={tableObjetos}
                  botaoAbrirOffCanvas={false}
                />
              </CustomCol>
            </CustomRow>
            <CustomCol style={{ marginTop: '15px', textAlign: 'right' }}>
              <CustomButton
                label="Nova Parcela"
                bgColor={theme.colors.botaoAcao.azul}
                textColor={theme.colors.white}
                onClick={() => {
                  handleShowModalParcela();
                }}
              />
            </CustomCol>

            {/* Modal Parcela /*/}
            <ModalTwo
              tituloModal="Parcela do Contrato"
              open={showModalParcela}
              onHide={handleShowModalParcela}
              icone="list"
              height="70vh"
              width="70vw"
              footer={
                <BarraInferiorBotoes>
                  {updatingParcela ? (
                    <WorkspaceBotoes
                      delete
                      onClickDelete={handleDelete}
                      save
                      onClickSave={handleUpdate}
                    />
                  ) : (
                    <WorkspaceBotoes inserir onClickInserir={handleCreate} />
                  )}
                </BarraInferiorBotoes>
              }
            >
              <WorkspaceFicha>
                <Log {...logObjetoData} />
                <BoxConteudo boxTitulo="Dados da Parcela">
                  <CustomRow style={{ marginTop: '-15px' }}>
                    <CustomCol width="75px">
                      <Input
                        name="link"
                        label="Nº"
                        value={1}
                        id="tagVersao"
                        type="number"
                        onChange={handleChange}
                      />
                    </CustomCol>
                    <CustomCol>
                      <SelectInput
                        name="statusVersao"
                        options={statusVersao}
                        label="Produto Farmacêutico"
                        value={formNotaVersao.statusVersao}
                        onChange={handleChange}
                        style={statusStyle}
                      />
                    </CustomCol>
                  </CustomRow>
                  <CustomRow>
                    <CustomCol width="175px">
                      <Input
                        name="link"
                        label="Fator Embalagem"
                        value={1}
                        id="tagVersao"
                        type="number"
                        onChange={handleChange}
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="100px">
                      <Input
                        name="link"
                        label="Parcelas"
                        value={1}
                        id="tagVersao"
                        type="integer"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="220px">
                      <Input
                        name="link"
                        label="Qtd Contratada"
                        value={1}
                        id="tagVersao"
                        type="integer"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="220px">
                      <Input
                        name="link"
                        label="Qtd Doada"
                        value={1}
                        id="tagVersao"
                        type="integer"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="220px">
                      <Input
                        name="link"
                        label="Qtd Total"
                        value={1}
                        id="tagVersao"
                        type="integer"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="150px">
                      <Input
                        name="link"
                        label="Valor Unitário R$"
                        value={1}
                        id="tagVersao"
                        onChange={handleChange}
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol>
                      <Input
                        name="link"
                        label="Valor Total R$"
                        value={1}
                        id="tagVersao"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                  </CustomRow>
                </BoxConteudo>
                <BoxConteudo boxTitulo="Observações" fechado>
                  <CustomRow style={{ marginTop: '-15px' }}>
                    <CustomCol>
                      <Input
                        id="observacoes"
                        name="observacoes"
                        value={formNotaVersao.observacoes}
                        label=""
                        type="textarea"
                        onChange={handleChange}
                        linhas={7}
                      />
                    </CustomCol>
                  </CustomRow>
                </BoxConteudo>
              </WorkspaceFicha>
            </ModalTwo>
          </BoxConteudo>

          {/* Pautas de Entrega */}
          <BoxConteudo boxTitulo="Pautas de Entregas">
            <CustomRow>
              <CustomCol width="100%">
                <Tabela
                  headers={headersPautasEntregasContratos}
                  dataTable={tableObjetos}
                  displayValues={valoresExibidosOffCanvasContratos}
                  onRowClick={handleShowModalPauta}
                  dataOffCanvas={tableObjetos}
                  botaoAbrirOffCanvas={false}
                />
              </CustomCol>
            </CustomRow>

            {/* Modal Pautas Entregas /*/}
            <ModalTwo
              tituloModal="Pauta de Entrega"
              open={showModalPauta}
              onHide={handleShowModalPauta}
              icone="list"
              height="70vh"
              width="70vw"
              footer={
                <BarraInferiorBotoes>
                  {updatingPauta ? (
                    <WorkspaceBotoes
                      delete
                      onClickDelete={handleDelete}
                      save
                      onClickSave={handleUpdate}
                    />
                  ) : (
                    <WorkspaceBotoes inserir onClickInserir={handleCreate} />
                  )}
                </BarraInferiorBotoes>
              }
            >
              <WorkspaceFicha>
                <Log {...logObjetoData} />
                <BoxConteudo boxTitulo="Dados da Pauta">
                  <CustomRow style={{ marginTop: '-15px' }}>
                    <CustomCol width="75px">
                      <Input
                        name="link"
                        label="Nº"
                        value={1}
                        id="tagVersao"
                        type="number"
                        onChange={handleChange}
                      />
                    </CustomCol>
                    <CustomCol>
                      <SelectInput
                        name="statusVersao"
                        options={statusVersao}
                        label="Produto Farmacêutico"
                        value={formNotaVersao.statusVersao}
                        onChange={handleChange}
                        style={statusStyle}
                      />
                    </CustomCol>
                  </CustomRow>
                  <CustomRow>
                    <CustomCol width="175px">
                      <Input
                        name="link"
                        label="Fator Embalagem"
                        value={1}
                        id="tagVersao"
                        type="number"
                        onChange={handleChange}
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="100px">
                      <Input
                        name="link"
                        label="Parcelas"
                        value={1}
                        id="tagVersao"
                        type="integer"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="220px">
                      <Input
                        name="link"
                        label="Qtd Contratada"
                        value={1}
                        id="tagVersao"
                        type="integer"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="220px">
                      <Input
                        name="link"
                        label="Qtd Doada"
                        value={1}
                        id="tagVersao"
                        type="integer"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="220px">
                      <Input
                        name="link"
                        label="Qtd Total"
                        value={1}
                        id="tagVersao"
                        type="integer"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="150px">
                      <Input
                        name="link"
                        label="Valor Unitário R$"
                        value={1}
                        id="tagVersao"
                        onChange={handleChange}
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol>
                      <Input
                        name="link"
                        label="Valor Total R$"
                        value={1}
                        id="tagVersao"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                  </CustomRow>
                </BoxConteudo>
                <BoxConteudo boxTitulo="Observações" fechado>
                  <CustomRow style={{ marginTop: '-15px' }}>
                    <CustomCol>
                      <Input
                        id="observacoes"
                        name="observacoes"
                        value={formNotaVersao.observacoes}
                        label=""
                        type="textarea"
                        onChange={handleChange}
                        linhas={7}
                      />
                    </CustomCol>
                  </CustomRow>
                </BoxConteudo>
              </WorkspaceFicha>
            </ModalTwo>
          </BoxConteudo>

          {/* Entregas */}
          <BoxConteudo boxTitulo="Entregas">
            <CustomRow>
              <CustomCol width="100%">
                <Tabela
                  headers={headersEntregasContratos}
                  dataTable={tableObjetos}
                  displayValues={valoresExibidosOffCanvasContratos}
                  onRowClick={handleShowModalEntrega}
                  dataOffCanvas={tableObjetos}
                  botaoAbrirOffCanvas={false}
                />
              </CustomCol>
            </CustomRow>

            {/* Modal Entregas /*/}
            <ModalTwo
              tituloModal="Entrega"
              open={showModalEntrega}
              onHide={handleShowModalEntrega}
              icone="check"
              height="70vh"
              width="70vw"
              footer={
                <BarraInferiorBotoes>
                  {updatingEntrega ? (
                    <WorkspaceBotoes
                      delete
                      onClickDelete={handleDelete}
                      save
                      onClickSave={handleUpdate}
                    />
                  ) : (
                    <WorkspaceBotoes inserir onClickInserir={handleCreate} />
                  )}
                </BarraInferiorBotoes>
              }
            >
              <WorkspaceFicha>
                <Log {...logObjetoData} />
                <BoxConteudo boxTitulo="Dados da Entrega">
                  <CustomRow style={{ marginTop: '-15px' }}>
                    <CustomCol width="75px">
                      <Input
                        name="link"
                        label="Nº"
                        value={1}
                        id="tagVersao"
                        type="number"
                        onChange={handleChange}
                      />
                    </CustomCol>
                    <CustomCol>
                      <SelectInput
                        name="statusVersao"
                        options={statusVersao}
                        label="Produto Farmacêutico"
                        value={formNotaVersao.statusVersao}
                        onChange={handleChange}
                        style={statusStyle}
                      />
                    </CustomCol>
                  </CustomRow>
                  <CustomRow>
                    <CustomCol width="175px">
                      <Input
                        name="link"
                        label="Fator Embalagem"
                        value={1}
                        id="tagVersao"
                        type="number"
                        onChange={handleChange}
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="100px">
                      <Input
                        name="link"
                        label="Parcelas"
                        value={1}
                        id="tagVersao"
                        type="integer"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="220px">
                      <Input
                        name="link"
                        label="Qtd Contratada"
                        value={1}
                        id="tagVersao"
                        type="integer"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="220px">
                      <Input
                        name="link"
                        label="Qtd Doada"
                        value={1}
                        id="tagVersao"
                        type="integer"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="220px">
                      <Input
                        name="link"
                        label="Qtd Total"
                        value={1}
                        id="tagVersao"
                        type="integer"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol width="150px">
                      <Input
                        name="link"
                        label="Valor Unitário R$"
                        value={1}
                        id="tagVersao"
                        onChange={handleChange}
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                    <CustomCol>
                      <Input
                        name="link"
                        label="Valor Total R$"
                        value={1}
                        id="tagVersao"
                        onChange={handleChange}
                        readonly
                        style={{ textAlign: 'right' }}
                      />
                    </CustomCol>
                  </CustomRow>
                </BoxConteudo>
                <BoxConteudo boxTitulo="Observações" fechado>
                  <CustomRow style={{ marginTop: '-15px' }}>
                    <CustomCol>
                      <Input
                        id="observacoes"
                        name="observacoes"
                        value={formNotaVersao.observacoes}
                        label=""
                        type="textarea"
                        onChange={handleChange}
                        linhas={7}
                      />
                    </CustomCol>
                  </CustomRow>
                </BoxConteudo>
              </WorkspaceFicha>
            </ModalTwo>
          </BoxConteudo>

          {/* Observações */}
          <BoxConteudo boxTitulo="Observações" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formNotaVersao.observacoes}
                  label=""
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            deleteDisabled={!canDelete}
            onClickDelete={handleDelete}
            save
            saveDisabled={!canSave}
            onClickSave={handleUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
